var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5V6M9.18055 2.82001C9.80974 3.4494 10.2382 4.25123 10.4117 5.1241C10.5852 5.99698 10.496 6.9017 10.1554 7.72388C9.81473 8.54607 9.23795 9.24878 8.49796 9.74318C7.75797 10.2376 6.888 10.5015 5.99805 10.5015C5.1081 10.5015 4.23812 10.2376 3.49814 9.74318C2.75815 9.24878 2.18137 8.54607 1.84073 7.72388C1.50009 6.9017 1.41089 5.99698 1.58441 5.1241C1.75792 4.25123 2.18636 3.4494 2.81555 2.82001",
    stroke: "#8E97CD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9ce7d02ffe34d5dedc2776e1c4bda0a4.svg";
export { ForwardRef as ReactComponent };